export default "__VITE_ASSET__TiXbZzhn__"